import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmt } from "../../lib/api";
import SectionCard from "./SectionCard";

export default function Kategori5({ factors, data, setData, results }) {
  return (
    <div className="space-y-6 animate-fadeInUp">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Kategori 5</div>
        <h2 className="font-display text-3xl font-semibold">Ürünlerin Kullanımı (Yaşam Döngüsü)</h2>
        <p className="text-muted-foreground mt-1 text-sm max-w-2xl">
          Kuruluşa ait ürünlerin yaşam döngüsü emisyonları (A5 - Montaj, B1-B7 Kullanım, C1-C4 Bertaraf).
          Otel/tesisler için genelde 0 kalır; ürünü olan kuruluşlar için uygulanabilir.
        </p>
      </div>

      <SectionCard title="Ürün Miktarı & Yaşam Döngüsü Emisyonları" total={results?.total}>
        <div className="mb-5 max-w-sm">
          <Label className="text-sm font-medium mb-1.5 block">Toplam Ürün Tonajı (ton)</Label>
          <Input type="number" step="any" value={data.urun_ton || ""}
                 onChange={(e) => setData((d) => ({ ...d, urun_ton: e.target.value }))}
                 placeholder="0" data-testid="k5-urun-ton" />
        </div>

        <div className="grid grid-cols-12 gap-2 text-[11px] uppercase tracking-wider text-muted-foreground px-1 pb-2">
          <div className="col-span-6">Aşama</div>
          <div className="col-span-3 text-right">EF (tCO₂e/ton)</div>
          <div className="col-span-3 text-right">Toplam (tCO₂e)</div>
        </div>
        {factors.kaynaklar.map((item, i) => {
          const res = results?.items?.find((x) => x.key === item.id)?.total || 0;
          return (
            <div key={item.id} className="grid grid-cols-12 gap-2 items-center py-1.5 border-t border-border/50">
              <div className="col-span-6">
                <div className="font-medium text-sm">{item.label}</div>
                <div className="text-[11px] text-muted-foreground">{item.assumption}</div>
              </div>
              <div className="col-span-3 text-right text-xs text-muted-foreground tabular-nums">
                {fmt(item.ef_per_ton, 5)}
              </div>
              <div className="col-span-3 text-right text-sm font-medium tabular-nums">
                {res > 0 ? fmt(res, 4) : "—"}
              </div>
            </div>
          );
        })}
      </SectionCard>
    </div>
  );
}
